import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import SortChip from 'src/components/ui/SortChip';
import FilterPlate from 'src/components/ui/FilterPlate';

const SortChips = (props) => {
	const { sorts = [], defaultTarget, target: targetProp } = props;

	const [targetState, setTarget] = useState(defaultTarget || null);
	const [anchorEl, setAnchor] = useState(null);

	const target = targetProp === undefined ? targetState : targetProp;

	const handleClose = useCallback(() => {
		setTarget(null);
		setAnchor(null);
	}, []);

	const handleClickItem = useCallback(
		(e, item) => {
			const canOpen = item.filter !== undefined || item.FilterRP;

			if (canOpen && target?.id !== item.id) {
				setAnchor(e.target);
				setTarget(item);
			} else {
				handleClose();
			}
		},
		[target, handleClose],
	);

	return (
		<>
			{sorts.length > 0 && (
				<Stack spacing={1.5} direction="row" alignItems="baseline">
					{sorts.map((item) => {
						return (
							<SortChip
								key={item.id}
								open={target?.id === item.id}
								onClick={(e) => {
									// Clickaway issue
									setTimeout(() => {
										handleClickItem(e, item);
									}, 0);
								}}
								{...item}
							/>
						);
					})}
				</Stack>
			)}
			{target && anchorEl && (
				<Popper
					id={target?.id}
					open
					anchorEl={anchorEl}
					placement="bottom-end"
				>
					{(target.FilterRP || target.filter) && (
						<ClickAwayListener onClickAway={handleClose}>
							<Box sx={{ width: 200 }}>
								{target.FilterRP ? (
									<target.FilterRP onClose={handleClose} />
								) : (
									<FilterPlate
										{...target.filter}
										onSubmit={(...args) => {
											target.filter.onSubmit?.(...args);
											handleClose();
										}}
										onCancel={(...args) => {
											target.filter.onCancel?.(...args);
											handleClose();
										}}
									/>
								)}
							</Box>
						</ClickAwayListener>
					)}
				</Popper>
			)}
		</>
	);
};

const TargetShape = {
	...SortChip.propTypes,
	filter: PropTypes.shape(FilterPlate.propTypes),
	FilterRP: PropTypes.elementType,
};

SortChips.propTypes = {
	target: PropTypes.shape(TargetShape),
	defaultTarget: PropTypes.shape(TargetShape),
	sorts: PropTypes.arrayOf(PropTypes.shape(TargetShape)),
};

export default SortChips;
